import { gql } from "@apollo/client";

export const QUERY_DISTRICTS = gql`
  query ($searchCriteria: String) {
    districts(searchCriteria: $searchCriteria) {
      id
      name
      nameGeneral
      schools {
        name
      }
      hidden
    }
  }
`;

export const QUERY_DISTRICT = gql`
  query District($id: ID!) {
    district(id: $id) {
      id
      name
      phone
      fax
      website
      address
      city
      state
      country
      zip
      directorOfEducation
      chairOfBoard
      logo
      selectedPlans
      hidden
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;

export const QUERY_DISTRICT_FORMS = gql`
  query districtForms($searchCriteria: String, $active: Boolean, $districtIds: [ID]) {
    districtForms(searchCriteria: $searchCriteria, active: $active, districtIds: $districtIds) {
      id
      active
      formId
      downloadFileName
      allowMultipleInstances
      form {
        id
        formCode
        name
      }
      districtId
      district {
        id
        name
        nameGeneral
      }
    }
  }
`;

export const QUERY_DISTRICT_FORM = gql`
  query districtForm($id: ID!) {
    districtForm(id: $id) {
      id
      active
      formId
      districtId
      district {
        id
        name
        nameGeneral
      }
      downloadFileName
      formWarning
      allowMultipleInstances
      form {
        id
        formCode
        name
      }
      subRolePermissions {
        enumName
        subRoleId
        add
        print
        view
      }
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;
